import React from "react";
import { DotLegalHeader, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import DotLegalSection from "@common/components/dotLegalSection/DotLegalSection";
import AnnualWheelSubTasks from "../../annualWheel/AnnualWheelSubTasks.tsx";
import { useTranslation } from "../../localization/useTranslation.ts";
import { isNullOrWhitespace } from "../../common/stringOperations.ts";
import MentionInput from "../../common/components/mentionInput/MentionInput.tsx";

export interface IAnnualWheelActivityStandardTemplateLanguageDataProps {
    name: string | undefined;
    description: string | undefined;
    subTasks: string[];
    showError?: boolean;
    onNameChange: (value: string) => void;
    onDescriptionChange: (value: string | undefined) => void;
    onSubTaskChange: (subTasks: string[]) => void;
}

function AnnualWheelActivityStandardTemplateLanguageData(props: IAnnualWheelActivityStandardTemplateLanguageDataProps) {
    const { name, description, subTasks, showError = false, onNameChange, onDescriptionChange, onSubTaskChange } = props;
    const { translateString } = useTranslation();

    return (
        <>
            <DotLegalHeader headerStyle="small" marginTop={2} marginBottom={0.5}>
                {translateString("createActivityName")}
            </DotLegalHeader>
            <DotLegalTextField
                noMargin
                debounce={false}
                label=""
                value={name ?? ""}
                onChange={onNameChange}
                errorText={showError && isNullOrWhitespace(name) ? translateString("fieldRequired") : undefined}
            />
            <DotLegalHeader headerStyle="small" marginTop={4} marginBottom={0.5}>
                {translateString("createActivityDescription")}
            </DotLegalHeader>
            <MentionInput noMargin multiline rows={8} debounce={false} value={description ?? ""} onChange={onDescriptionChange} disableMentions />

            <DotLegalHeader marginBottom={0.5} marginTop={3} headerStyle="small">
                {translateString("createActivitySubTasks")}
            </DotLegalHeader>
            <DotLegalSection>
                <AnnualWheelSubTasks
                    subTasks={subTasks.map((x) => ({ id: x, name: x, relations: [] }))}
                    onChange={(tasks) => onSubTaskChange(tasks.map((x) => x.name))}
                />
            </DotLegalSection>
        </>
    );
}

export default AnnualWheelActivityStandardTemplateLanguageData;
